export const dateStringToLocalTime = (dateString: string) =>
  dateString.replace("Z", "");
